import { apiClient } from '@/utils/api-client';
import type {
  DealCostPage,
  DealCost,
  DealCostInvestment,
  DealCostResolve,
  DealCostUpdate,
  DealCostsSummary,
} from '@/types/deal-costs';

export const dealCostService = {
  async list(
    fundId: string,
    params?: {
      portfolio_company_id?: string;
      page?: number;
      page_size?: number;
    }
  ): Promise<DealCostPage> {
    return await apiClient.get(`/funds/${fundId}/deal-costs`, { params });
  },

  async summary(fundId: string): Promise<DealCostsSummary> {
    return await apiClient.get(`/funds/${fundId}/deal-costs/summary`);
  },

  async get(fundId: string, costId: string): Promise<DealCost> {
    return await apiClient.get(`/funds/${fundId}/deal-costs/${costId}`);
  },

  async listInvestments(fundId: string): Promise<DealCostInvestment[]> {
    return await apiClient.get(`/funds/${fundId}/deal-costs/investments`);
  },

  async update(
    fundId: string,
    costId: string,
    data: DealCostUpdate
  ): Promise<DealCost> {
    return await apiClient.patch(`/funds/${fundId}/deal-costs/${costId}`, data);
  },

  /** Closes or aborts a pending deal cost. */
  async resolve(
    fundId: string,
    costId: string,
    data: DealCostResolve
  ): Promise<DealCost> {
    return await apiClient.post(
      `/funds/${fundId}/deal-costs/${costId}/resolve`,
      data
    );
  },

  async delete(fundId: string, costId: string): Promise<void> {
    await apiClient.delete(`/funds/${fundId}/deal-costs/${costId}`);
  },
};
